var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAARElEQVR42mMYfOD/mf9n8Eu7t3QBleCWZkhjUDkQB1eCqRso6f7fHaQEQxodYpqShglJMeF/2qpZ6BBiAgIYY0I6BT4A7YNRvJjAPzcAAAAASUVORK5CYII=";
  export default img;